import 'jquery-migrate';

// После загрузки jquery-migrate нам необходимо уведомить ожидающий коллбек, что скрипт подрядчиков можно выполнять
if (typeof window.jqueryMigrateOnLoad === 'function') {
    window.jqueryMigrateOnLoad();
}
